import styled from 'styled-components';

import { PageElementActionButton } from '../styles';
import { NewStyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface ToggleProps {
	isOpened: boolean;
}

const Toggle = styled(PageElementActionButton)`
	background-color: ${({ isOpened }: ToggleProps) => isOpened ? NewStyleColor.Blue450 : NewStyleColor.Black};
`;

const Panel = styled('div')`
	box-sizing: border-box;
	width: 50px;
	border-radius: 8px;
	background-color: ${NewStyleColor.Grey1000};
	color: ${NewStyleColor.White};
	box-shadow: 0 2px 14px 0 ${hexToRgba(NewStyleColor.Black, 32)};
	cursor: default;
`;

const PanelInner = styled('div')`
	padding: 6px;
`;

const IconMove = styled('div')`
	display: flex;
	justify-content: center;
	width: 30px;
	height: 22px;
	margin: 0 auto;
	cursor: move;

	svg {
		width: 19px;
		height: 18px;
		fill: ${hexToRgba(NewStyleColor.White, 35)};
		transform: rotate(90deg);
	}
`;

export {
	Toggle,
	Panel,
	PanelInner,
	IconMove,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ActionsPanel/styles.ts